const apiUrl = 'https://ciplpgapi.azurewebsites.net';
const imageUrl = 'https://ciplpgapi.azurewebsites.net';
const apiUrlAddEdit = 'https://ciplpgapi.azurewebsites.net';
const crmUrl = 'https://aapkapgcrm.aapkapg.com';
 
// const apiUrl = 'https://kyspgapi.azurewebsites.net';
// const imageUrl = 'https://kyspgapi.azurewebsites.net';
// const apiUrlAddEdit = 'https://kyspgapi.azurewebsites.net';
// const crmUrl = 'https://aapkapgcrm.aapkapg.com';

// const apiUrl = 'http://localhost:5000';
// const imageUrl = 'http://localhost:5000';
// const apiUrlAddEdit = 'http://localhost:3000';
// const crmUrl = 'http://localhost:5173';

export { apiUrl, imageUrl, apiUrlAddEdit, crmUrl };